type SetFormValue = (name: string, value: unknown, options?: { shouldValidate?: boolean }) => void;

/** Clears everything that depends on the selected ad account. */
export const clearPinterestDownstreamSelections = (setValue: SetFormValue): void => {
  setValue('selectedCampaigns', []);
  setValue('selectedAdGroups', []);
  setValue('$adGroupsData', []);
};
